import React, { useEffect } from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { InTheLab } from './components/InTheLab';
import { Differentiators } from './components/Differentiators';
import { StudioStory } from './components/StudioStory';
import { LabFaq } from './components/LabFaq';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  useEffect(() => {
    document.title = 'Black Comet Labs — Small studio. Big apps.';
  }, []);
  return <div className="min-h-full w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="2mmlvl877gb6d">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-[2px] focus:bg-ink focus:px-5 focus:py-3 focus:text-sm focus:text-cream" data-id="element-1" data-mp="31aqfgfhzusqq">
        Skip to content
      </a>
      <SiteHeader data-id="element-2" data-mp="28sutgkvsztko" />
      <main id="main" data-id="element-3" data-mp="28sb9yzqi8x4j">
        <Hero data-id="element-4" data-mp="23vcmh01cjofb" />
        <InTheLab data-id="element-5" data-mp="23vuoyeelqyvo" />
        <Differentiators data-id="element-6" data-mp="23u9vyt7xrnzx" />
        <StudioStory data-id="element-7" data-mp="23v2sl1d6kx4c" />
        <LabFaq data-id="element-8" data-mp="23ti5fwt74ggi" />
      </main>
      <SiteFooter data-id="element-9" data-mp="3ikr002qv3a7b" />
    </div>;
}